import { render, staticRenderFns } from "./PlainConcepts.vue?vue&type=template&id=1aa05708&scoped=true&"
import script from "./PlainConcepts.vue?vue&type=script&lang=js&"
export * from "./PlainConcepts.vue?vue&type=script&lang=js&"
import style0 from "./PlainConcepts.vue?vue&type=style&index=0&id=1aa05708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa05708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa05708')) {
      api.createRecord('1aa05708', component.options)
    } else {
      api.reload('1aa05708', component.options)
    }
    module.hot.accept("./PlainConcepts.vue?vue&type=template&id=1aa05708&scoped=true&", function () {
      api.rerender('1aa05708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/PlainConcepts.vue"
export default component.exports